import { render, staticRenderFns } from "./ReactivationOnboardInitial.vue?vue&type=template&id=75b6d82d&"
import script from "./ReactivationOnboardInitial.vue?vue&type=script&lang=js&"
export * from "./ReactivationOnboardInitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports